import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary'
import { MyStudentsPage } from '@features/my-students/components/MyStudentsPage'
import { requireRouteAudience } from '@services/router/routeAccess'
import { createFileRoute } from '@tanstack/react-router'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { Suspense } from 'react'

export const Route = createFileRoute('/_layout/students/my')({
    component: RouteComponent,
    beforeLoad: requireRouteAudience(['staff']),
    staticData: {
        crumb: {
            label: "My Students"
        }
    }
})

function RouteComponent() {
    return (
        <QueryErrorBoundary title='Failed to load your students'>
            <Suspense fallback={<LoadingIndicator resource='your students'/>}>
                <MyStudentsPage />
            </Suspense>
        </QueryErrorBoundary>
    )
}
